export default "__VITE_ASSET__BXkHHfrj__"